import { streamingRestApi } from '@/service/streamingApi'
import { PipelinePastProvision } from '@/types/streams/pipeline'

import { createBaseTableStore } from '../table'
import { FetchApiArgs, FetchApiResponse } from '../table/table.types'

const fetchApi = async (args: FetchApiArgs): Promise<FetchApiResponse<PipelinePastProvision>> => {
  const { signal } = args

  const { data } = await streamingRestApi.endpoints.pipeline.getPastProvisioned(signal)

  return {
    content: data,
    totalElements: data.length
  }
}

export const usePastProvisionStore = createBaseTableStore<PipelinePastProvision>({
  storeName: 'DGE Past Provisioned',
  fetchApi
})
